// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__G1wH-","signatureBlock":"Footer_signatureBlock__xSvZ2","signature":"Footer_signature__3DbNY"};